import axios from 'axios';
import Qs from 'qs';
// import {Loading, Notification} from 'element-plus'
import { Toast } from 'vant';

// 环境变更切换地址
if (process.env.NODE_ENV == "development") {
    axios.defaults.baseURL = "/api"
} else if (process.env.NODE_ENV == "debug") {
    axios.defaults.baseURL = '';
} else if (process.env.NODE_ENV == 'production') {
    axios.defaults.baseURL = '/api' //'/api'
}

function crateOption(opt) {
    return {
        url: opt.url, //string
        params: opt.params, //object
        success: opt.success, //function(res)
        fail: opt.fail //function(res)
    }
}

// 请求超时
// axios.defaults.timeout = 30000;

// post请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'

// 请求拦截器
// let loadingInstance = null;
axios.interceptors.request.use((config) => {
    // Get请求序列化
    if (config.method === 'get') {
        config.paramsSerializer = (params) => {
            return Qs.stringify(params, { arrayFormat: 'repeat' })
        }
    }
    // 启动loading
    // loadingInstance = Loading.service({
    //     text: `loading...`,
    //     background: "rgba(100, 100, 100, 0.5)"
    // });
    // console.log(config)
    return config
}, (error) => {
    // console.log(error)
    return Promise.error(error)
})

// 响应拦截
axios.interceptors.response.use((resolve) => {

    // loadingInstance.close() //关闭loading
    // 判断响应状态
    if (resolve.status === 200) {
        return Promise.resolve(resolve)
    } else {
        return Promise.reject(resolve)
    }
}, (error) => {
    // 响应错误信息
    if (error.response.status) {
        switch (error.response.status) {
            case 400:
                Toast('请求错误,请刷新页面后重试！');
                break;
            case 403:
                Toast('拒绝访问,请刷新页面后重试！');
                break;
            case 404:
                Toast('请求不存在,请刷新页面后重试！');
                break;
            case 408:
                Toast('请求超时,请刷新页面后重试！');

                break;
            case 500:
                Toast('服务器错误,请稍后重试！');
                break;
            case 502:
                Toast('网络错误,请稍后重试！');
                break;
            case 504:
                Toast('网络超时,请稍后重试！');
                break;
            default:
                Toast(`${error.response.statusText},请稍后重试！`);
                break
        }
        return Promise.reject(error.response)
    }
})


const get = (option) => {
    if (option && option.url && option.params) {
        // if (option.token == undefined || option.token == null || option.token == "") {
        //     window.location.href = "/login";
        //     return;
        // }
        axios.defaults.headers.common["token"] = option.token;
        if (option.isDownload) {
            window.open(option.url)
        }

        new Promise((resolve, reject) => {
            axios.get(option.url, {
                    params: option.params
                })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }).then(function(result) {
            if (result.status == 200) {
                if (option.success) {
                    option.success(result.data)
                }
            } else {
                if (option.fail) {
                    option.fail(result.statusText)
                }
            }
        })
    }
}

// post方法  key value 形式
const postForm = (url, params) => {
    return new Promise((resolve, reject) => {
        axios.post(url, Qs.stringify(params))
            .then(response => resolve(response))
            .catch(error => reject(error))
    })
}

const postJsonWithToken = (url, params) => {
    return new Promise((resolve, reject) => {
        axios.defaults.headers.common["token"] = localStorage.getItem("token");
        axios.post(url, params)
            .then(response => resolve(response))
            .catch(error => reject(error))
    })
}

//  const postJson = (url, params) => {
//     return new Promise((resolve, reject) => {
//         axios.post(url, params)
//             .then(response => resolve(response))
//             .catch(error => reject(error))
//     })
// }
const postJson = (url, params, callback) => {
    new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(response => resolve(response))
            .catch(error => reject(error))
    }).then(function(result) {
        if (result.status == 200) {
            callback.success(result.data)
        } else {
            callback.failed(result.statusText)
        }

    })
}

const post = (option) => {
    if (option && option.url && option.params) {
        new Promise((resolve, reject) => {

            axios.defaults.headers.common["token"] = option.token;
            axios.post(option.url, option.params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }).then(function(result) {
            if (result.status == 200) {
                if (option.success) {
                    option.success(result.data)
                }
            } else {
                if (option.fail) {
                    option.fail(result.statusText)
                }
            }
        })
    } else {
        console.log("非法的option参数")
    }
}

const postNoToken = (option) => {
    if (option && option.url && option.params) {
        new Promise((resolve, reject) => {
            axios.post(option.url, option.params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }).then(function(result) {
            if (result.status == 200) {
                if (option.success) {
                    option.success(result.data)
                }
            } else {
                if (option.fail) {
                    option.fail(result.statusText)
                }
            }
        })
    } else {
        console.log("非法的option参数")
    }
}

export default {
    postForm,
    postJson,
    postJsonWithToken,
    crateOption,
    get,
    post,
    postNoToken
}


// const services = axios.create({
//     baseURL:"",
//     timeout:5000,
//     headers:{
//     }
// })
// // 请求拦截器
// services.interceptors.request.use((config)=>{
//     console.log(config);
//     config.headers[""] = ""
// })
// // 响应拦截器
// services.interceptors.response.use((resolve)=>{
//     console.log(resolve)
//     return resolve
// })
